import axios from 'axios'

import { API_ROOT } from './constants'

// A random id this browser keeps for Morsel. The server stores only a scrambled copy, so
// the admin can see when two accounts are used from the same browser (second accounts).
const DEVICE_KEY = 'morsel_device'
const deviceId = () => {
  try {
    let id = window.localStorage.getItem(DEVICE_KEY)
    if (!id || !/^[A-Za-z0-9-]{16,64}$/.test(id)) {
      id = window.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join('')
      window.localStorage.setItem(DEVICE_KEY, id)
    }
    return id
  } catch (e) {
    return null
  }
}

const rawRequest = async (url, method = 'get', options = {}) => {
  const referer = global.window?.location?.href || '/'
  let params = {
    ...options,
    url,
    method,
    headers: {
      ['X-Referer']: referer,
    },
  }
  const device = deviceId()
  if (device) params.headers['X-Morsel-Device'] = device
  params.url = API_ROOT + url

  return axios(params).then(({ data }) => data)
}

const getFileRequest = async (url, data = {}) => {
  return rawRequest(url, 'get', { params: data, responseType: 'arraybuffer' })
}

const getRequest = async (url, data = {}) => {
  return rawRequest(url, 'get', { params: data })
}

const postRequest = async (url, data = {}) => {
  return rawRequest(url, 'post', { data })
}

const putRequest = async (url, data = {}) => {
  return rawRequest(url, 'put', { data })
}

const deleteRequest = async (url, data = {}) => {
  return rawRequest(url, 'delete', { data })
}

const uploadRequest = async (url, data = {}, method = 'put') => {
  const formData = new FormData()

  for (const field of Object.entries(data)) {
    const [key, value] = field
    formData.append(key, value)
  }

  return rawRequest(url, method, { data: formData })
    .then(({ data }) => data)
    .catch((e) => {
      console.log(e)
      return e
    })
}

const setHandlers = (onSuccess, onError) => {
  const defaultSuccessHandler = (response) => response
  const defaultErrorHandler = (e) => {
    console.log(`\n\nERROR\n\n${e}`)
    throw e
  }

  axios.interceptors.response.use(
    onSuccess ? onSuccess : defaultSuccessHandler,
    onError ? onError : defaultErrorHandler
  )
}

const getToken = () => axios.defaults.headers.common['Authorization']

export default {
  getFile: getFileRequest,
  get: getRequest,
  post: postRequest,
  delete: deleteRequest,
  put: putRequest,
  upload: uploadRequest,
  setHandlers,
  getToken,
}
